/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function PlatformAnalytics({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
  <path fillRule="evenodd" clip-rule="evenodd" d="M3.333 2C2.597 2 2 2.597 2 3.333v9.334C2 13.403 2.597 14 3.333 14h9.334c.736 0 1.333-.597 1.333-1.333V3.333C14 2.597 13.403 2 12.667 2H3.333Zm2 5.333c.369 0 .667.299.667.667v3.333a.667.667 0 1 1-1.333 0V8c0-.368.298-.667.666-.667ZM8 4c.368 0 .667.298.667.667v6.666a.667.667 0 1 1-1.334 0V4.667C7.333 4.298 7.632 4 8 4Zm3.333 6A.667.667 0 1 0 10 10v1.333a.667.667 0 0 0 1.333 0V10Z" fill="#918EEB"></path>

    </svg>
  );
}
